import { getIsAcceleratorPlan } from "../Utils/services";

export const getIsEfaxIntegrationAccessible = () => {
  return getIsAcceleratorPlan();
};

export const getIsRepeatMdIntegrationAccessible = () => {
  return getIsAcceleratorPlan();
};

export const getIsJoyaIntegrationAccessible = () => {
  return getIsAcceleratorPlan();
};
